export default "__VITE_ASSET__PM7Vxmoh__"